/**************
 Global
 ***************/

// get index of a specific element
function getElIndex(el) {
    let i;
    for (i = 0; el = el.previousElementSibling; i++) ;
    return i;
}

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}


// print price ($51.27 = 5127)
function price(amount) {
    let total = (parseFloat(amount) / 100).toFixed(2);
    return `$${total.replace(".00", "")}`;
}

// Debounce
function debounce(func, time = 100) {
    let timer;
    return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
}


// open tooltip dialog
function openTooltip(id) {
    // open dialog
    document.querySelector(`#tooltip-${id}`).showModal();
    document.querySelector("body").classList.add("noScroll");
}

// open tooltip event listener
if (window.window.innerWidth < 801) {
    document.querySelectorAll(".openTooltip").forEach(function (element) {
        element.addEventListener("click", function () {
            openTooltip(this.dataset.id);
        });
    });
}

// close tooltip
function closeToolTip(id) {
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector(`#tooltip-${id}`).close();
}

//close tooltip listener
document.querySelectorAll(".tooltipDialogHeaderClose").forEach(function (element) {
    element.addEventListener("click", function () {
        closeToolTip(this.dataset.id);
    });
});
// register dialogs
document.querySelectorAll(".tooltipDialog").forEach(function (element) {
    dialogPolyfill.registerDialog(document.querySelector(`.tooltipDialog#${element.id}`));
});